import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F80C6B02-D422-44FE-9199-B9E12EF523C8
 * name chevron-triple-right
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-triple-right.svg
 * tags
 */
export const ChevronTripleRightIcon = createSvgIcon(<><path d="M14.58,16.59L19.17,12L14.58,7.41L16,6L22,12L16,18L14.58,16.59M8.58,16.59L13.17,12L8.58,7.41L10,6L16,12L10,18L8.58,16.59M2.58,16.59L7.17,12L2.58,7.41L4,6L10,12L4,18L2.58,16.59Z" /></>, 'ChevronTripleRightIcon');
export default ChevronTripleRightIcon